import { render, staticRenderFns } from "./BelposhtaProduct.vue?vue&type=template&id=d0b018d4&scoped=true"
import script from "./BelposhtaProduct.vue?vue&type=script&lang=js"
export * from "./BelposhtaProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0b018d4",
  null
  
)

export default component.exports